import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  url, 
  image,
  keywords,
  type = 'website',
  author = 'MatkaBar',
  noIndex = false
}) => {
  // Default values
  const siteTitle = 'MatkaBar';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Play Matka Online | Full Rate Betting Platform`;
  
  const defaultDescription = 'MatkaBar - India\'s trusted online matka platform. Play matka online with full rate, best game rates, historical charts for Panna, Jodi, Jackpot and Starline games. Join thousands of players today.';
  const pageDescription = description || defaultDescription;
  
  const defaultKeywords = 'MatkaBar, matka online, play matka, matka betting, panna chart, jodi chart, jackpot, starline, online gambling, matka game, full rate matka, bookmakers india, kalyan matka';
  const pageKeywords = keywords || defaultKeywords;
  
  const baseUrl = 'https://kalyan7.com';
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : baseUrl);
  const pageImage = image || `${baseUrl}/logo.png`;
  
  // Canonical URL (remove query params and trailing slashes)
  const canonicalUrl = pageUrl.split('?')[0].replace(/\/$/, '');
  
  // Structured Data - Organization
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": siteTitle,
    "alternateName": "MatkaBar",
    "description": "Online matka betting platform with full rate and best game rates",
    "url": baseUrl,
    "logo": `${baseUrl}/logo.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": ["English", "Hindi"],
      "areaServed": "IN"
    },
  };

  // Structured Data - WebSite
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": siteTitle,
    "url": baseUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${baseUrl}/search?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };


  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang="en" />
      <title>{fullTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Robots */}
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'} />
      <meta name="googlebot" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:alt" content={title || siteTitle} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteTitle} />

      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      <meta name="twitter:image:alt" content={title || siteTitle} />
      
      {/* Additional Meta Tags */}
      <meta name="theme-color" content="#000000" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="MatkaBar" />
      <meta name="application-name" content="MatkaBar" />
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="format-detection" content="telephone=no" />
      <meta http-equiv="x-ua-compatible" content="ie=edge" />

      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;